/** PowerPoint (PPTX) の MIME タイプ。 */
export const PPTX_MIME =
    "application/vnd.openxmlformats-officedocument.presentationml.presentation";
